// 检测沉浸式翻译浏览器弹窗
export const findChromeBrowserPopup = () => {
  const popup = /(immersive-translate)(.*?)popup/.test(
    document.documentElement.innerHTML,
  );
  return popup;
};
